import get from "lodash/get";
import { connect } from "react-redux";
import Header from "../Components/Header";
import { saveArtusConfiguration } from "../reducers/Artus/Actions";
import { saveBertArchiveConfiguration } from "../reducers/BertArchive/Actions";
import { saveBertWarehouseConfiguration } from "../reducers/BertWarehouse/Actions";
import { dismissError, reportError, setVisible, setWorkInProgress } from "../reducers/Ui/Actions";
import { Services } from "../ServiceLocator";
import { createScreenshot } from "../Utils/CreateScreenshot";
import {resetConfigurationCode, saveConfiguration} from "../reducers/Configuration/Actions";

const mapStateToProps = (state) => {
  return {
    Component: Header,
    title: get(state, "Configuration.configuration.item.title", ""),
  };
};
const mapDispatchToProps = (dispatch) => ({
  loadConfiguration: () => dispatch(setVisible("loadConfiguration", true)),
  saveConfiguration: () => dispatch(saveConfiguration()),
  sendMail: async () => {
    if (Services.store.state.ui.error) {
      dispatch(dismissError());
    }
    const configuration = Services.store.state.Configuration.configuration;
    const itemIdentifier = configuration && configuration.item ? configuration.item.identifier : "";
    const screenshot = await createScreenshot(itemIdentifier.includes("artus"));
    dispatch(setWorkInProgress("mailConfiguration", true));
    dispatch(setVisible("optionlist", false));
    dispatch(setVisible("mailConfiguration", true));

    try {
      dispatch(
        itemIdentifier.includes("bertWarehouse")
          ? saveBertWarehouseConfiguration("user", screenshot)
          : itemIdentifier.includes("bertArchive")
          ? saveBertArchiveConfiguration("user", screenshot)
          : saveArtusConfiguration("user", screenshot)
      );
    } catch (e) {
      console.error(e);
      dispatch(reportError(e));
    } finally {
      dispatch(setWorkInProgress("mailConfiguration", false));
    }
    dispatch(setVisible("sendEmail", true));
  },
  downloadPdf: async () => {
    if (Services.store.state.ui.error) {
      dispatch(dismissError());
    }
    const configuration = Services.store.state.Configuration.configuration;
    const itemIdentifier = configuration && configuration.item ? configuration.item.identifier : "";
    const screenshot = await createScreenshot(itemIdentifier.includes("artus"));
    await dispatch(resetConfigurationCode());
    dispatch(setWorkInProgress("printConfiguration", true));
    dispatch(setVisible("optionlist", false));
    dispatch(setVisible("printConfiguration", true));
    dispatch(setVisible("globalLoader", true));

    try {
      dispatch(
        itemIdentifier.includes("bertWarehouse")
          ? saveBertWarehouseConfiguration("print", screenshot)
          : itemIdentifier.includes("bertArchive")
          ? saveBertArchiveConfiguration("print", screenshot)
          : saveArtusConfiguration("print", screenshot)
      );
    } catch (e) {
      console.error(e);
      dispatch(reportError(e));
    } finally {
      dispatch(setWorkInProgress("printConfiguration", false));
      dispatch(setVisible("globalLoader", false));
    }
    dispatch(setVisible("pdfDownload", true));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
